import React from 'react';
import { Stack, Typography } from '@mui/material';

import styles from '../overlaysStyle.module.scss';

export const BatteryEmpty = () => (
  <Stack
    data-testid="camera-overlay-battery-empty"
    direction="column"
    spacing={10}
    alignItems="center"
    justifyContent="center"
  >
    <Typography variant="h3" className={styles.textSize}>
      Empty battery <br />
      Please charge your device
    </Typography>
  </Stack>
);
